export default __webpack_public_path__ + "static/media/tick_white.41d83838.svg";